import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import queryString from 'query-string';
import moment from '../../../modules/moment';
import { storeQueryString, retrieveQueryString } from '../../query';
import { ensureDatesAreValid } from '../../../modules/dates';
import { getViewData } from '../../../modules/view-data';
import constants from '../../../constants';

const isHomepage = $('body').hasClass('template-homepage');

try {
    if (!window.localStorage.getItem('search-location')) {
        window.firstSearch = true;
    }
} catch (e) {
    // TODO: find better way to store this
}

const queryData = queryString.parse(location.search, {
    arrayFormat: 'bracket',
});

storeQueryString(queryData);

// Store any new data from the query string
const searchData = (isHomepage)
    ? {}
    : retrieveQueryString();

delete searchData.location;
delete searchData.lat;
delete searchData.lng;

const searchParams = {
    location: getViewData('searchParams.location', null),
    lat: getViewData('searchParams.lat', null),
    lng: getViewData('searchParams.lng', null),
    rental: getViewData('searchParams.rental', null)
        || getViewData('searchParams.default_search_rental', 'long'),
    start_date: null,
    start_time: null,
    end_date: null,
    end_time: null,
};

if (getViewData('searchParams.start', null)) {
    searchParams.start_date = moment(getViewData('searchParams.start')).format('DD-MM-YYYY');
    searchParams.start_time = moment(getViewData('searchParams.start')).format('HH:mm');
}

if (getViewData('searchParams.end', null)) {
    searchParams.end_date = moment(getViewData('searchParams.end')).format('DD-MM-YYYY');
    searchParams.end_time = moment(getViewData('searchParams.end')).format('HH:mm');
}

const endMoment = moment().floor(30, 'minute').add(2, 'hours');
let writableSearchData = {
    location: searchData.location || searchParams.location,
    lat: searchData.lat || searchParams.lat,
    lng: searchData.lng || searchParams.lng,
    rental: searchData.rental || searchParams.rental,
    start_date: searchData.start_date || searchParams.start_date || moment().format('DD-MM-YYYY'),
    start_time: searchData.start_time || searchParams.start_time || moment().floor(30, 'minute').format('HH:mm'),
    end_date: searchData.end_date || searchParams.end_date || endMoment.format('DD-MM-YYYY'),
    end_time: searchData.end_time || searchParams.end_time || endMoment.format('HH:mm'),
    type: queryData.type || 'both',
    space_size: queryData.space_size || 'motorcycle',
    features: queryData.features || [],
    page: searchData.page || 1,
    per_page: getViewData('searchParams.per_page'),
    radius: getViewData('searchParams.radius'),
    spaces_available: searchData.spaces_available || 1,
};

if (
    (!isHomepage && writableSearchData.rental === 'long' && !searchData.start_date)
    || (isHomepage && constants.HOMEPAGE_DEFAULT_RENTAL === 'long')
) {
    writableSearchData.start_date = moment().add(2, 'days').format('DD-MM-YYYY');
}

writableSearchData = ensureDatesAreValid(writableSearchData);

// We'll default to london if they somehow got to the search
// without params - otherwise they get a big nasty infinite loop!
if ($('body').hasClass('page-search')) {
    writableSearchData.location = writableSearchData.location || '';
    writableSearchData.lat = writableSearchData.lat || 51.5074;
    writableSearchData.lng = writableSearchData.lng || -0.1278;
}

// initial state
export default {
    // Search results
    results: get(window.YPS, 'initialResults.data', []),
    initialResults: get(window.YPS, 'initialResults.data', []),
    // Default model data
    defaults: cloneDeep(writableSearchData),
    // Live model data
    data: writableSearchData,
    // Static copy of the live model data at time of search
    // Use this rather than the above to show data
    // in a read-only context
    currentSearch: cloneDeep(writableSearchData),
    center: {
        lat: null,
        lng: null,
    },
    meta: {
        pagination: get(window.YPS, 'initialResults.meta.pagination', {
            count: null,
            current_page: 1,
            links: {},
            per_page: null,
            total: null,
            total_pages: null,
        }),
    },
    searching: false,
    noSpacesFoundModalShown: false,
    filtersVisible: false,
    searchComponents: {
        list: false,
        map: false,
    },
    hoveredSpace: null,
    activeSpace: null,
    obtainedLocation: {
        lat: null,
        lng: null,
    },
};
